import { jsx } from "react/jsx-runtime";
import React from "react";
export function VeTopRightContainer({ fullScreen, children }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: fullScreen ? { right: 65, top: 10 } : {},
      className: "veTopRightContainer",
      children
    }
  );
}
